import React from 'react'

const LoaderDots = () => {
  return (
    <div className='loader-dots'>
      <div className="gooey">
        <div className="dot"></div>
        <div className="dots">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default LoaderDots
